import { SiExpress } from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";

export const html = {
  title: "HTML",
  img: "https://cdn-icons-png.flaticon.com/512/1532/1532556.png",
  wid: "70%",
  swid: "40%",
};

export const css = {
  title: "CSS",
  img: "https://cdn4.iconfinder.com/data/icons/iconsimple-programming/512/css-512.png",
  wid: "65%",
  swid: "40%",
};

export const javascript = {
  title: "JavaScript",
  img: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
  wid: "60%",
  swid: "40%",
};

export const react = {
  title: "React.js",
  img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
  wid: "75%",
  swid: "40%",
};

export const chakra = {
  title: "Chakra UI",
  img: "https://img.icons8.com/color/512/chakra-ui.png",
  wid: "75%",
  swid: "40%",
};

export const redux = {
  title: "Redux",
  img: "https://cdn.iconscout.com/icon/free/png-256/free-redux-283024.png",
  wid: "70%",
  swid: "40%",
};

export const chartjs = {
  title: "Chart.js",
  img: "https://www.richardwestenra.com/painting-with-data-talk/img/libs/recharts.png",
  wid: "100%",
  swid: "",
};

export const node = {
  title: "Node.js",
  img: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png",
  wid: "65%",
  swid: "40%",
};

export const mongodb = {
  title: "MongoDB",
  img: "https://devkico.itexto.com.br/wp-content/uploads/2013/10/mongodb-leaf-300x300.png",
  wid: "65%",
  swid: "40%",
};

export const express = {
  title: "Express",
  img: "https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png",
  svg: SiExpress,
  wid: "60%",
  swid: "40%",
};

export const tailwind = {
  title: "Tailwind CSS",
  img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png",
  wid: "70%",
  swid: "50%",
};

export const nextjs = {
  title: "Next.js",
  img: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
  wid: "65%",
  svg: TbBrandNextjs,
  swid: "36%",
};

export const git = {
  title: "Git",
  img: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
  wid: "65%",
  swid: "40%",
};

export const typescript = {
  title: "TypeScript",
  img: "https://w7.pngwing.com/pngs/915/519/png-transparent-typescript-hd-logo-thumbnail.png",
  wid: "65%",
  swid: "40%",
};

export const python = {
  title: "Python",
  img: "https://img.freepik.com/free-icon/snakes_318-368381.jpg",
  wid: "70%",
  swid: "40%",
};

export const promptEngineering = {
  title: "Prompt Engineering",
  img: "https://static.vecteezy.com/system/resources/previews/021/495/996/original/chatgpt-openai-logo-icon-free-png.png",
  wid: "70%",
  swid: "35%",
};

export const mySQL = {
  title: "MySQL",
  img: "https://img.icons8.com/fluency/240/mysql-logo.png",
  wid: "70%",
  swid: "40%",
};

export const java = {
  title: "Java",
  img: "https://img.icons8.com/fluency/240/java-coffee-cup-logo.png",
  wid: "70%",
  swid: "40%",
};

export const php = {
  title: "PHP",
  img: "https://img.icons8.com/external-those-icons-flat-those-icons/96/external-PHP-programming-and-development-those-icons-flat-those-icons.png",
  wid: "70%",
  swid: "40%",
};

export const c_programming = {
  title: "C Pragramming",
  img: "https://img.icons8.com/fluency/240/c-programming.png",
  wid: "70%",
  swid: "40%",
};
export const kotlin = {
  title: "Kotlin",
  img: "https://img.icons8.com/color/480/kotlin.png",
  wid: "70%",
  swid: "40%",
};

export const machinelearning = {
  title: "Machine learning",
  img: "https://raw.githubusercontent.com/scikit-learn/scikit-learn/main/doc/logos/scikit-learn-logo.png",
  wid: "70%",
  swid: "60%",
};


export const wireshark = {
  title: "Wireshark",
  img: "https://upload.wikimedia.org/wikipedia/commons/c/c6/Wireshark_icon_new.png",
  wid: "70%",
  swid: "40%",
};

export const linux = {
  title: "Linux",
  img: "https://img.icons8.com/external-those-icons-flat-those-icons/96/external-Linux-logos-and-brands-those-icons-flat-those-icons.png",
  wid: "70%",
  swid: "40%",
};

export const kalilinux = {
  title: "Kali Linux",
  img: "https://img.icons8.com/color/480/kali-linux.png",
  wid: "70%",
  swid: "40%",
};

export const flaskicon = {
  title: "Flask",
  img: "https://img.icons8.com/ios-filled/500/flask.png",
  wid: "70%",
  swid: "40%",
};

export const rstudio = {
  title: "R Studio",
  img: "https://upload.wikimedia.org/wikipedia/commons/d/d0/RStudio_logo_flat.svg" ,
  wid: "70%",
  swid: "80%",
};

export const androidstudio = {
  title: "Android Studio",
  img: "https://img.icons8.com/color/144/android-studio--v3.png" ,
  wid: "70%",
  swid: "40%",
};


export const supabaseIcon = {
  title: "Supabase",
  img: "https://img.icons8.com/fluency/240/supabase.png" ,
  wid: "70%",
  swid: "40%",
};

export const docker = {
  title: "docker",
  img: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/96/external-docker-a-set-of-coupled-software-as-a-service-logo-color-tal-revivo.png" ,
  wid: "70%",
  swid: "40%",
};


export const gemini = {
  title: "gemini",
  img: "https://img.icons8.com/fluency/96/gemini-ai.png",
  wid: "70%",
  swid: "40%",
};



export const playwright = {
  title: "playwright",
  img: "https://cdn.brandfetch.io/idpyc8TcWP/w/400/h/400/theme/dark/icon.png?c=1dxbfHSJFAPEGdCLU4o5B",
  wid: "70%",
  swid: "40%",
};